<template>
    <div v-if="getPermission.ccic.view || getPermission.stc.view">  

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <span class="heading2">{{photoTitle}}</span>
        <calling-api path="/api/w/ccr/photo/getCCRPhoto">
          <div v-if="photos.length === 0">
            <h3>You don't have any photos from CCR Log</h3>
          </div>
          <div v-else>
            <view-image  :key="p.imgUrl" :src="p.imgUrl" v-for="p in photos">
            <div v-if="!isLoading" class="space">
                <h3>Type: {{p.title}}</h3>
                <p>File Name: {{getPhotoName(p)}}</p>
              </div>
              <div v-if="isLoading" class="space">
                <p>File Name: {{getPhotoName(p)}}</p>
                <p>{{p.refTimeStamp}}</p>
              </div>            
            </view-image>
          </div>
        </calling-api>
      </md-dialog-content>

      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"
                                  v-if="isLoading"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-dialog :md-active.sync="isFilterModalShowing">
      <md-dialog-content>
        <h1>Additional Search</h1>
        
        <!-- 1 -->
        <div class = "inputBoxDouble" > 
          <div class = "inputBoxSpace" > 
            <auto-complete-master-data-select
              label="Stage Type"
              display-type="idOnly"
              :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_STAGE_TYPE')"
              :init-value-id="searchRequest.stageType"
              :on-item-changed="handleTypeChanged">
            </auto-complete-master-data-select>
          </div>
          <div class = "inputBoxSpace">
            <md-field>
              <label>Freight Type</label>
              <md-input v-model="searchRequest.freightType"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace" >
            <auto-complete-master-data-select
              group="CCR_CNTRTYPE"
              label="Container Type"
              :init-value="searchRequest.ctnrType"
              :on-item-changed="handleCtnrTypeChanged">
            </auto-complete-master-data-select>
          </div>

          <div class = "inputBoxSpace" >
            <auto-complete-master-data-select
              group="GST_STAGE_STATUS"
              label="Stage Status"
              :init-value="searchRequest.stageStatus"
              :on-item-changed="handleStageStatusChanged">
            </auto-complete-master-data-select>
          </div>

          <div class = "inputBoxSpace">
            <auto-complete-master-data-select
              group="PUSH_STATUS"
              label="Push Status"
              :init-value="searchRequest.pushStatus"
              :on-item-changed="handlePushStatusChanged">
            </auto-complete-master-data-select>
          </div>
        </div>

        <!-- 2 -->
        <div class = "inputBoxDouble" > 
          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.apptDate.startDate" >
              <label>Appt.From</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.apptDate.endDate">
              <label>Appt.To</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.cargoCutOff.startDate" >
              <label>CargoCut From</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.cargoCutOff.endDate">
              <label>CargoCut To</label>
            </datepicker>
          </div>
        </div>


        <!-- 3 -->
        <div class = "inputBoxDouble" > 
            <div class = "inputBoxSpace" >
            <auto-complete-master-data-select
              group="DriverGroup"
              label="Driver Group"
              :init-value="searchRequest.driverGroup"
              :on-item-changed="handleDrGroupChanged">
            </auto-complete-master-data-select>
          </div>

          <div class = "inputBoxSpace">
            <auto-complete-master-data-select
              :prepared-options="drivers"
              label="Driver"
              :init-value="searchRequest.driver"
              :on-item-changed="handleDriverRequestChanged">
            </auto-complete-master-data-select>
          </div>

          <div class = "inputBoxSpace">
            <md-field>
              <label>STC DO</label>
              <md-input v-model="searchRequest.deliveryOrder"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace">
            <md-field>
              <label>Customer Order</label>
              <md-input v-model="searchRequest.customerOrder"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace">
            <md-field>
              <label>Appointment</label>
              <md-input v-model="searchRequest.appointment"/>
            </md-field>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    
    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
            <div class = "inputBoxSpace1" >
               <auto-complete-master-data-select
                  group="REC_WINDOW"
                  label="Rev. Windows"
                  :init-value="searchRequest.receivingWindow"
                  :on-item-changed="handleWindowsChanged">
               </auto-complete-master-data-select>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
            <div class = "inputBoxSpace1">
                  <md-field>
                    <label size="lg" class = "textlabel" for="loadStatus">Load Status</label>
                      <md-select v-model="searchRequest.loadStatus">
                      <md-option value="DCP">DCP Delivery Completed</md-option>
                      <md-option value="CFM">CFM Load Conform</md-option>
                      <md-option value="BLC">BLC Bill/Cost Conform</md-option>
                      <md-option value="LOK">LOK Bill/Cost Locked</md-option>
                    </md-select>
                  </md-field>
            </div>
          </div>  

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxSpace">
              <auto-complete-master-data-select
                label="Carrier Name"
                display-type="idOnly"
                :prepared-options="this.getMasterDataAsSelectOptionByGroup('STC_CARRIER')"
                :init-value-id="searchRequest.carrier"
                :on-item-changed="handleCarrierChanged">
              </auto-complete-master-data-select>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxSpace">
              <md-field>
                <label>Pick up Location</label>
                <md-input v-model="searchRequest.pickupLocation"/>
              </md-field>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxSpace">
              <md-field>
                <label>Destination</label>
                <md-input v-model="searchRequest.destination" />
              </md-field>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxSpace">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo" />
              </md-field>
            </div>
          </div>

          <div  v-if="active" class="md-layout-item md-size-10 md-small-size-100">
            <md-button
              class="custButtonFilter md-raised"
              @click="filterBar"> <span class="icons-center material-icons">find_in_page</span>
              More
            </md-button>
          </div>

          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <div class="result-included-outter-div">
              <div class="result-included-inner-div-radio">
                <span class="result-included-span-radio"> 
                Dispatch Type: 
                </span>
                <md-radio v-model="selectDType" value="YE"  @change="onSelectDType" >Yard Export</md-radio>
                <md-radio v-model="selectDType" value="E"  @change="onSelectDType" >Export</md-radio>  
                <md-radio v-model="selectDType" value="I"  @change="onSelectDType" >Import</md-radio>  
                <md-radio v-model="selectDType" value="TL"  @change="onSelectDType" >Truck Load</md-radio>  
              </div>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100"> 
            <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/gst/WebSearchDispatchList']">
              <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">
               <b-notification class = "notifySize"
                  type="is-success"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
               </b-notification>
               <!-- <md-button class="md-raised custMedButton md-accent" :disabled="!canUnconf" @click="doUnconf" ><span class="icons-center material-icons">reply</span>Unconf Load</md-button> -->
               <md-button class="md-raised custMedButton md-primary" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons">details</span>Detail</md-button>
               <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">search</span>Search</md-button>
               <md-button   @click="doClear" class="md-raised custButton"><span class="icons-center material-icons">clear</span>Clear</md-button>
      
             <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"

                    />
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container ">
            <div class="inner-container table-wrapper ">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2">
                      <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                      <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip>
                    </th>
                    <th class="header-cell center w2" v-on:click="sortFunction('receivingWindows')">Rec.W</th>
                    <th class="header-cell center w4" v-on:click="sortFunction('billingNum')">Inv#</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load ID</th>
                    <th class="header-cell center w3" v-on:click="sortFunction('loadStatus')">Status</th>
                    <th class="header-cell center w4" v-on:click="sortFunction('deliveryOrder')">DO#</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('customerOrder')">CustomerPO</th>

                    <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Container</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">Chassis</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">custID</th>
                    
                    <th class="header-cell center w4" v-on:click="sortFunction('sealNumber')">Seal #</th>
                    <!-- <th class="header-cell center w3" v-on:click="sortFunction('ctnrType')">CTNR Type</th> -->
                    <!-- <th class="header-cell center w2" v-on:click="sortFunction('grade')">Grade</th> -->
                    <th class="header-cell center w4" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('bookingNo')">Booking #</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('cutLFD')">CargoCutOff</th>
                    <!-- <th class="header-cell center w3" v-on:click="sortFunction('appointment')">Appmt</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('apptDate')">Appt Date</th> -->
                    <!-- <th class="header-cell center w3" >Appt Time</th> -->
                    <!-- <th class="header-cell center w5" >Driver.Grp</th> -->
                    <!-- <th class="header-cell center w5" v-on:click="sortFunction('driverId')">Driver</th> -->
                    <!-- <th class="header-cell center w4" v-on:click="sortFunction('truckId')">Truck ID</th> -->
                    <th class="header-cell center w4">CTNR Image</th>
                    <!-- <th class="header-cell center w10" v-on:click="sortFunction('driverRemark')">Driver Remark</th> -->
                    <!-- <th class="header-cell center w3" v-on:click="sortFunction('pushStatus')">Push Status</th> -->
                    <th class="header-cell center w2" v-on:click="sortFunction('source')">Source</th>
                    <th class="header-cell center w5">Used Day</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">Out Gate Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzEndDate')">In Gate Date</th>
                    
                    <!-- <th class="header-cell center w3" v-on:click="sortFunction('locationNumber')">Yard Loc.</th> -->
                    <!-- <th class="header-cell center w4" v-on:click="sortFunction('scaleTicket')">Weight Ticket</th> -->
                    <th class="header-cell center w7" v-on:click="sortFunction('pickUpLocationName')">Pickup Loc</th>
                    <th class="header-cell center w7" v-on:click="sortFunction('deliverLocationCode')">Delivery To</th>
                    <th class="header-cell center w7" v-on:click="sortFunction('pickupTerm')">Pickup Tml</th>
                    <!-- <th class="header-cell center w5" >Route</th>
                    <th class="header-cell center w10" >Route Desc</th> -->
                    <!-- <th class="header-cell center w10" >Instruction</th> -->
                    
                  </tr>
                  </thead>
                </table>
              </div>


              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                    <td class="body-cell w2"><md-checkbox v-model="item.selected"></md-checkbox></td>
                    <td class="body-cell excelBox w2">{{item.receivingWindow}}</td>
                    <td  class="body-cell excelBox w4">{{item.billingNum}}</td>
                    <td  class="body-cell excelBox w5">{{item.seqNo}}</td>
                    <td class="body-cell excelBox w3">{{item.loadStatus}}</td>
                    <td class="body-cell excelBox w4">{{item.deliveryOrder}}</td>
                    <td  class="body-cell excelBox w5">{{item.customerOrder}}</td>
                    
                    <td  class="body-cell excelBox w5">{{item.containerNo}}</td>
                    <td  class="body-cell excelBox w5">{{item.chassisNo}}</td>
                    <td  class="body-cell excelBox w5">{{item.custID}}</td>

                    <td  class="body-cell excelBox w4">{{item.sealNumber}}</td>
                    <!-- <td  class="body-cell excelBox w3">{{item.ctnrType}}</td> -->
                    <!-- <td  class="body-cell excelBox w2">{{item.grade}}</td> -->
                    <td  class="body-cell excelBox w4">{{item.carrier}}</td>
                    <td  class="body-cell excelBox w5">{{item.bookingNo}}</td>
                    <td  class="body-cell excelBox w5">{{item.cutLFD | date}}</td>
                    <!-- <td class="body-cell excelBoxTB w3">
                      <template v-if="disableAppt">
                        {{item.appointment}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.appointment"/>
                      </md-field>
                      </template>
                      
                    </td> -->
                    <!-- <td class="body-cell excelBox w5">
                      <template v-if="disableAppt">
                        {{showApptDate(item)}}
                      </template>
                      <template v-else>
                        <div style="min-width:160px">
                        <datepicker v-model="item.apptDate">
                      </datepicker>
                        </div>
                      </template>
                      </td>
                      <td class="body-cell excelBox w3">
                      <template v-if="disableAppt">
                        {{item.apptTime}}
                      </template>
                      <template v-else>
                         <md-field>
                          <md-input v-model="item.apptTime"/>
                        </md-field>
                      </template>
                      </td> -->
                    <!--<td class="body-cell excelBox w5">{{item.apptDate | time}}</td>-->
                    <!-- <td class="body-cell excelBox w5">
                      <template v-if="isSetDriverGroup">
      
                          <auto-complete-master-data-select
                                     group="DriverGroup"
                                     :init-value="item.driverGroup"
                                     :on-item-changed="changeDriverGroup(item)"
                          >
                          </auto-complete-master-data-select>

                        </template>
                        <template v-else>
                          {{ item.driverGroup }}
                        </template>
                    </td> -->
                    <!-- <td class="body-cell excelBox w5">
                      <template v-if="isAsgDriver">
                        <auto-complete-master-data-select
                                                :prepared-options="drivers"
                                                :init-value="item.driverId"
                                                :on-item-changed="changeAsgDriverId(item)"
                                                >
                        </auto-complete-master-data-select>

                      </template>
                        <template v-else>
                          {{ item.driverId }}
                        </template>

                    </td> -->
                    <!-- <td class="body-cell excelBox w4">{{item.truckId}}</td> -->
                    <td class="body-cell excelBox w4">
                        <template v-if="item.driverCntrImg != null">
                          <a href="" @click.prevent="toggleItemLink1(item)" target="_blank" rel="noopener">      
                            1 image
                            </a>
                        </template>  
                        <template v-else>
                            0 image
                        </template>  
                    </td>
                    <!-- <td class="body-cell excelBox w10">{{item.driverRemark}}</td> -->
                    <!-- <td class="body-cell excelBox w3">{{getPushStatusInfo(item.pushStatus)}}</td> -->
                    
                    <td  class="body-cell excelBox w2">{{item.source}}</td>
                    <td  class="body-cell excelBox w5">{{getChassisUsedDate(item)}} Days</td>
                    <td  class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                    <td  class="body-cell excelBox w5">{{item.chzEndDate | date}}</td>
                    <!-- <td  class="body-cell excelBox w3"><div class = "spaceLine">{{item.yard}} {{item.locationNumber}}</div></td> -->
                    <!-- <td  class="body-cell excelBox w4">{{item.scaleTicket}}</td> -->
                    <td  class="body-cell excelBox w7">{{item.pickUpLocationName}}</td>

                    <td class="body-cell excelBox w7">
                        <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                    </td>
                    <td class="body-cell excelBox w7">
                        <master-data-display group="STC_TERMINAL" :tag-id="item.pickupTerm"/>
                    </td>
                    
                    <!-- <td class="body-cell excelBox w5"> {{item.route}}</td>
                     <td class="body-cell excelBox w10"> {{item.routeDesc}}</td> -->
                    <!-- <td class="body-cell excelBox w10">{{item.dispatcherInstruction}}</td> -->
                    
                   </tr>
 
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>





</template>


<style scoped>

.inputBoxDouble {
  width: 1100px;
  justify-content: left;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputBoxSpace1 {
  width: 120px;
}


.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.spaceLine {
  margin-bottom: 10px;
}
.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}
.excelBox {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
}
.excelBoxTB {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-right: 5px;
  
}
.excelBoxLeft {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}
.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
}
.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
      
}
.selected {
     background: yellow;
}
.tableW {
    height: 40px;
}
.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}
.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}
.md-menu {
  padding: 0;
  padding: 0;

}
.custButton {
    margin: 10px;
    width: 90px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
}
.custButtonFilter{
   margin: 10px;
    width: 130px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
}
.custMedButton {
    margin: 10px;
    width: 110px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
}
.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
}
.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}
.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}
.result-included-inner-div-radio {
    margin-left: 0px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-outter-div {
    border: 3px solid #89cfe8;
    border-radius: 5px;
    width: 600px;
    padding: 10px;
    height: 43px;
    margin-top: 3px;
    margin-bottom: 5px;
    margin-left: 10px;
}

</style>



<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


const initSearchCriteria = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
 
})


const getInitSearch = () => ({
    users: [],
    teams: [],
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driver: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: ['CFM'],
    pushStatus: null,
    stageType: null
  });

  const savedPageStateInfo = () => ({
    receivingWindow: null,
    loadStatus: null,
    carrier: null,
    pickupLocation: null,
    destination: null,
    containerNo: null,
    selectDType: null,
    stageType: null,
    freightType: null,
    ctnrType: null,
    stageStatus: null,
    pushStatus: null,
    apptDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    driverGroup: null,
    driver: null,
    deliveryOrder: null,
    customerOrder: null,
    appointment: null
  })

  const initCockpitReq = () => ({
     mode: null,
     carrierName: null,
     customerPO: null,
     customerOrder: null,
     route: null,
     deliveryOrder: null,
     loadKey: null,
     bookingNo: null
  })

  const initSearchDriverGroup = () => ({
     seqNo: null,
     driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null
  })

  const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
  })

  const driverInfo = () => ({
     id: null,
     name: null 
  })

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      cockpitRequest: initCockpitReq(),
      searchCriteria: initSearchCriteria(),
      searchDriverGroupReq: initSearchDriverGroup(),
      searchDriverSearchReq: getInitDriverSearch(),
      pageStateInfo: savedPageStateInfo(), 
      active: false,
      drivers: [],
      items: [],
      selectedItems: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      active: false,
      sortStatus: true,
      filter: "",
      containerCopy: false,
      selectAll: false,
      notifyMessage: null,
      notifyActive: false,
      selectDType: "YE",
      isPictureModalShowing: false,
      photoZipFileName: '',
      filePrefixForEachFile: '',
      isLoading: false,
      isdownloadzip: false,
      imgPath: null,
      photoTitle: "Photos",
      photos: [],
      singleReq: [],
      isSetDriverGroup: false,
      isSetAppointment: false,
      isAsgDriver: false,
      isSetPIN: false,
      isConfirm: false,
      isYI: false,
      disableSave: false,
      disableAppt: true,
      driverGroups: [],
      stcDriverGroups: [],
      stcDriverGroupOption: [],
      driverIds: [],
      driverNames: [],
      driverContent: [],
      showDropDown: false,
      isFilterModalShowing:false,
    }),


    components: {
      AutocompleteCcicLocationSelect,
      UpdateCcicContainerStatusForm,
      CcicPhotoForm,
      callingApiCenter,
    },

    watch: {
      getYardExportList(val) {
        this.updateItems(val);
      },
      getDirectExportList(val) {
        this.updateItems(val);
      },
      getTruckLoadList(val) {
        this.updateItems(val);
      },
      getImportLoadList(val) {
        this.updateItems(val);
      },

      // eslint-disable-next-line
      "searchRequest.teams"() {
         this.searchRequest.users = [];
      },
      notifyActive(val) {
        if (val == false)
        {
          this.notifyMessage = null;
        }
      },
  
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getYardExportList',
        'getImportLoadList',
        'getTruckLoadList',
        'getDirectExportList',
        'getSTCDriverGroup',
        'getGSTDriverMaster'
      ]),


      filteredRows(){
        
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.containerNo).includes(term) ||
                 this.includeNull(row.chassisNo).includes(term) ||
                //  this.includeNull(row.loadKey).includes(term)||
                 this.includeNull(row.seqNo).includes(term)||
                 this.includeNull(row.loadStatus).includes(term)||
                 this.includeNull(row.stageStatus).includes(term)||
                 this.includeNull(row.stageType).includes(term)||
                 this.includeNull(row.bookingNo).includes(term);
        })
      },



      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      getAssignBookingCond() {

        const items = _(this.items).filter((it) => it.selected);
        const LD = items.filter((it) => it.loadStatus == 'ASN');
        if (LD.length != 0) return false;
        const weighted = _(items).filter((it) => it.weight != null);
        if (items.length == 0) return false
        const ctnrType = [...new Set(items.map(s => s.ctnrType))];
        const grade = [...new Set(items.map(s => s.grade))];
        const carrier = [...new Set(items.map(s => s.carrier))];
        // carrier.length === 1
        const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
        if (sapStatus.length == 0) return false
        console.log("grade: " + grade + ":" + grade.length + " ctnrType: " + ctnrType + ":" + ctnrType.length);
        return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1

      },

      getUnAssignBookingCond() { 
         console.log("unassign cond");
         const item = _(this.items).filter((it) => it.selected);
         const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
         if (sapStatus.length == 0) return false
         console.log("unassign item length:" + item.length);
         return item.length === 1 && item[0].loadStatus == 'ASN'
      },
  
      getSelectedItems() {
        return _(this.items).filter((it) => it.selected);
      },


      canOutGate(){
        return this.getSelectedItems.length != 0
      },


      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },

      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },


      canEdit() {
        return this.getSelectedItems.length != 0 ;
      },


      canSave() {
        console.log("canSave: " + this.disableSave);
        return this.disableSave;
      },

      noGates(){
          if (this.getSelectedItems.length == 0)
          {
            return false
          }
          var gates = false
          this.getSelectedItems.forEach((it) => {
            if (it.loadKeyWithStageNo == null)
            {
              gates = true
            }
          });
          return !gates;
      },

      // canSave() {
      //   return !!_(this.getEditingItems)
      //     .find(it => !!this.hasBeenChanged(it));
      // },

      canUnconf(){
        const item = _(this.items).filter((it) => it.selected);
        const sapStatus = _(this.items).filter((it) => it.loadStatus == 'CFM');
        if (sapStatus.length == 0) return false
        return this.getSelectedItems.length === 1 && this.getSelectedItems[0].loadStatus == 'CFM'
      },

      canDelete(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        return true


      },

      canDeleteBooking() {
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].deliveryOrder == null)
        {
          return false
        }

        return true
      },


      canDeleteLoad(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        if (this.getSelectedItems[0].loadStatus != "JO")
        {
          return false
        }

        return true


      },

      getDownloadCond() {
          const item = _(this.items).filter((it) => it.selected);
          if (item.length == 0 && this.items.length != 0) return this.items;

      },
    },

    async mounted() {
      this.doSearch();
      this.drivers = [];
      //console.log("location")
      //console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOCATION'))
      // this.$store.dispatch('getUsersByCategory', { category: 'L' })
      //   .then((res) => {
      //     this.drivers = res;
  
      //   });
      this.searchDriverSearchReq.driverOffice = "STC";
      this.searchDriverSearchReq.defaultSalesOffice = "LGB";
      await this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq)
        .then(() => {
            //console.log(`driver list: ${JSON.stringify(this.getGSTDriverMaster)}`);
            if (this.getGSTDriverMaster != null && this.getGSTDriverMaster.length > 0)
            {
               this.getGSTDriverMaster.forEach((it) => {
                   var driver = driverInfo();
                   driver.id = it.driverId;
                   driver.name = it.shortId;
                   this.drivers.push(driver);
               });
            }
        });
        //await this.updateDrivers(this.getGSTDriverMaster); 
        //this.updateDrivers(this.getGSTDriverMaster); 
        //console.log("driver from getter: " + this.driverNames);
        this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.$el.querySelector('#expand-button').click();
        const cachedSearchRequest = this.$store.state.yardExportList.searchRequest;
        // if (cachedSearchRequest) {
        //  this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
        // }
        if (this.$route.name != null)
           console.log("router name: " + this.$route.name);
        if (this.$route.params != null)
           if (this.$route.params.req != null) {
              console.log("dispatchload: router params: " + this.$route.params.req);
              var searchCriteria = JSON.parse(this.$route.params.req);
              console.log("fallback searchCriteria: " + searchCriteria + ", containerNo: " + searchCriteria.containerNo);
              //console.log("fallback containerNo: " + this.$route.params.req.containerNo);
              this.searchRequest.containerNo = searchCriteria.containerNo;
              this.handleWindowsChanged(searchCriteria.receivingWindow);
              //this.searchRequest.salesOffice = searchCriteria.salesOffice;
              this.searchRequest.pickupLocation = searchCriteria.pickupLocation;
              //this.searchRequest.bookingNo = searchCriteria.bookingNo;
              this.searchRequest.destination = searchCriteria.destination;
              this.searchRequest.appointment = searchCriteria.appointment;
              this.searchRequest.driver = searchCriteria.driver;
              this.searchRequest.driverGroup = searchCriteria.driverGroup;
              //this.searchRequest.costRelevant = searchCriteria.costRelevant;
              this.searchRequest.freightType = searchCriteria.freightType;
              this.searchRequest.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
              this.searchRequest.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
              this.searchRequest.apptDate.startDate = searchCriteria.apptDate.startDate;
              this.searchRequest.apptDate.endDate = searchCriteria.apptDate.endDate;
              //this.searchRequest.loadKey = searchCriteria.loadKey;
              //this.searchRequest.source = searchCriteria.source;
              //this.searchRequest.chassisNo = searchCriteria.chassisNo;
              this.searchRequest.carrier = searchCriteria.carrier;
              this.searchRequest.customerOrder = searchCriteria.customerOrder;
              this.searchRequest.deliveryOrder = searchCriteria.deliveryOrder;
              this.searchRequest.loadStatus = searchCriteria.loadStatus;
              this.handlePushStatusChanged(searchCriteria.pushStatus);
              this.searchRequest.stageType = searchCriteria.stageType;
              //this.filter = searchCriteria.filter;
              this.selectDType = searchCriteria.selectDType;
              //this.searchRequest.containerNo = "NYKU5163735";
           }   
           else
              console.log("no router req info");   
        else
           console.log("no router params info");   
        this.$el.querySelector('#searchTag').click();
        console.log("select D type: " + this.selectDType);
        if (this.selectDType == "YE") {
            console.log("YardExportList");
            this.searchRequest.type = "";
            this.updateItems(this.getYardExportList);
        }
        else if (this.selectDType == "I") {
            console.log("ImportLoadList");
            this.searchRequest.type = "YI";
            this.updateItems(this.getImportLoadList);
        }
        else if (this.selectDType == "E") {
            console.log("DirectExportList");
            this.searchRequest.type = "YE";
            this.updateItems(this.getDirectExportList);
        }  
        else if (this.selectDType == "TL") {
            console.log("TruckLoadList");
            this.searchRequest.type = "YT";
            this.updateItems(this.getTruckLoadList);  
        }  
        // switch (this.selectDType) {
        //   default: 
        //     console.log("YardExportList");
        //     this.updateItems(this.getYardExportList);
        //   case 'I':
        //     console.log("ImportLoadList");
        //     this.updateItems(this.getImportLoadList);
        //   case 'E':
        //     console.log("DirectExportList");
        //     this.updateItems(this.getDirectExportList);
        //   case 'TL':    
        //     console.log("TruckLoadList");
        //     this.updateItems(this.getTruckLoadList);  
        // }

        //this.updateItems(this.getYardExportList);
        this.disableSave = true;
        this.isSetAppointment = false;
        this.isSetDriverGroup = false;
        this.isAsgDriver = false;
        this.disableAppt = true;
        this.isSetPIN = false;
        if (this.selectDType == "I") {
           this.isYI = true;
        } else {
           this.isYI = false;
        }
        
        this.$store.dispatch('stcDriverGroup', this.searchDriverGroupReq);
        //await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
        await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
          this.stcDriverGroups = driverGroup;
        })

        //console.log("stc driver groups: " + JSON.stringify(allSTCDriverGroups)); 
        //console.log("stc driver groups: " + this.getSTCDriverGroup); 
        console.log("stc driver groups: " + JSON.stringify(this.stcDriverGroups))
        //const allSTCDriverGroups = this.getSTCDriverGroup;
        if (this.stcDriverGroups) {
          this.stcDriverGroups.forEach( (val) => {
              this.stcDriverGroupOption.push(val.driverGroup);
          }
          )
          
        }      

        console.log("stcDriverGroupOption: " + this.stcDriverGroupOption);
        console.log("isYI: " + this.isYI); 
    },

     methods: {

       handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },

      sortFunction(sortFiled){
                const nullValues = _.filter(this.items, (item) => {
                  return item[sortFiled] == null
                })
                const values = this.items.filter(it => it[sortFiled] != null);
                const sorted = _.sortBy(values,sortFiled).concat(nullValues);
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
          },



      handleWindowsChanged(id) {
        this.searchRequest.receivingWindow = id;
      },
      handleDrGroupChanged(id) {
        this.searchRequest.driverGroup = id;
      },
      handleStageStatusChanged(id) {
        this.searchRequest.stageStatus = id;
      },
      handleCtnrTypeChanged(id) {
        this.searchRequest.ctnrType = id;
      },

      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },

      toggleDispatch(element) {
          alert("call to pop-up dispatch" + element);
      },

        updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
          if (this.notifyMessage != null)
          {
            this.notifyActive = true;
            
          }

       },

      getPhotoName(photo) {
          const photoName = decodeURI(photo.imgUrl.replace(/.*\//g, ""));
          return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

      async toggleItemLink(item) {
           const logId = "DISPATCH";
           const imgType = "C";
           this.isPictureModalShowing = true;
           this.isLoading = true;
           //this.photos = (await api.post('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
           this.photos = (await newAPIPost('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
           console.log("photos length: " + this.photos.length);
           if (item.loadKey != null)
              this.photoZipFileName = `${logId}_${item.loadkey}.zip`;
           else
              this.photoZipFileName = `${logId}_` + imgType + `.zip`;
           this.filePrefixForEachFile = `${item.containerNo}-`;
           this.photoTitle = "Container Image";
           console.log(this.photos)
           //window.open(item.driverCntrImg, 'test', 'width=400,height=200,scrollbars=yes'); 

      },

      toggleItemLink1(item) {
         var imgLink = "";
         var title = "";
         var width;
         var height;
         var leftPos;
         var topPos;
         var settings = "";
         var userWidth = screen.availWidth;
         var userHeight = screen.availHeight;        
         width =  400;
         height = 200;
         //leftPos = (userWidth - width) /2;
         //leftPos = 1500;
         leftPos = userWidth - 500;
         topPos = (userHeight - height) /2;
         console.log("leftPos: " + leftPos + " topPos: " + topPos);
         console.log("avail height: " + userHeight + " avail width: " + userWidth);
         settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
         settings += ',scrollbars=yes';
         console.log("settings: " + settings);
         imgLink = item.driverCntrImg;
         title = "Driver Container Image";
        if (! window.focus)return true;
           var href;
        if (typeof(imgLink) == 'string') href=imgLink;
        else href=imgLink.href; 
        //window.open(href, title, 'width=400,height=200,scrollbars=yes'); 
        console.log("href: " + href);
        if (href.toString().indexOf('http') < 0) {
           console.log("index: " + href.toString().indexOf('http'));
           alert("Not a valid picture path");
        }   
        else {
          window.open(href, title, settings,true);
        }
        return false;         
      },

      filterBar(){
        this.isFilterModalShowing = true;
      },


       onSelectDType(val) {
          console.log("Dispatch type: " + val);
          this.selectDType = val;
          if (this.selectDType == "I") this.isYI = true; else this.isYI = false;
          this.doSearch();
       },
       
       doSearch() {

       
          const {
          users,
          teams,
          salesOffice,
        } = this.searchRequest;
        this.active = true;

        this.items = [];
        //this.searchRequest.chzStartDate.startDate = moment().subtract(2,'months').startOf('d').toDate();
        //this.searchRequest.chzStartDate.endDate = moment().add(2,'months').endOf('d').toDate();
        console.log("search request-loadStatus: " + this.searchRequest.loadStatus);
        this.searchRequest.salesOffice = "LGB";
        console.log("select D type: " + this.selectDType);
        if (this.selectDType == "YE") {
            console.log("search:YardExportList");
            this.searchRequest.type = "YY";
            this.$store.dispatch('loadYardExportList', this.searchRequest);
        }
        else if (this.selectDType == "I") {
            console.log("search:ImportLoadList");
            this.searchRequest.type = "YI";
            //this.$store.dispatch('importLoadList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', this.searchRequest);
        }
        else if (this.selectDType == "E") {
            console.log("search:DirectExportList");
            this.searchRequest.type = "YE";
            //this.$store.dispatch('directExportList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', this.searchRequest);
        }  
        else if (this.selectDType == "TL") {
            console.log("search:TruckLoadList");
            this.searchRequest.type = "YT";
            //this.$store.dispatch('truckLoadList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', this.searchRequest);
        }  

        // switch (this.selectDType) {
        //   default:
        //     this.searchRequest.type = "";
        //     console.log("search:YardExportList");
        //     this.$store.dispatch('loadYardExportList', this.searchRequest);
        //   case 'I':
        //     this.searchRequest.type = "YI";
        //     console.log("search:ImportLoadtList");
        //     this.$store.dispatch('importLoadList', this.searchRequest);
        //   case 'E':
        //     this.searchRequest.type = "YE";
        //     console.log("search:DirectExportList");
        //     this.$store.dispatch('directExportList', this.searchRequest);
        //   case 'TL':      
        //     this.searchRequest.type = "YT";
        //     console.log("search:TruckloadList");
        //     this.$store.dispatch('truckLoadList', this.searchRequest);
        // }
        // this.isSetDriverGroup = false;
        // this.isSetAppointment = false;
        // this.isAsgDriver = false;
        // this.isSetPin = false;
        // this.isConfirm = false;
        // this.disableSave = true;
        // this.disableAppt = true;

       },

      // async doDeleteBooking(){
      //     const request = this.getSelectedItems[0];
      //     const data = {
      //       user: 'GST_SYSTEM',
      //       seqNo: request.seqNo,
      //       mode: "REMOVE"
      //     }
      //     api.post("/api/w/DOs/WebAssignDoHeaderWithStage", data)
      //     .then(() => {
      //       this.$store.commit('clearApiError');
      //       this.doSearch();
      //     });
      // },


      //  async doDeleteStage(){
      //   const request = this.getSelectedItems[0];
      //     console.log(request);
      //     const data = {
      //       companyOffice: "GST_" + request.salesOffice,
      //       loadKeyWithStageNo: request.loadKeyWithStageNo,
      //       type: request.type || "YY",
      //       loadKey: request.seqNo,
      //       action: "DELETE_STAGE",
      //     }
      //     if (request.loadKeyWithStageNo == null)
      //     {
      //       alert('There is no stage selected');
      //       return;
      //     }

      //     api.post("/api/w/gst/WebCopyDeleteStage", data)
      //     .then(() => {
      //       this.$store.commit('clearApiError');
      //       this.doSearch();
      //     });

      //  },

       async onfresh(id, ticket, mode, loads) {
         console.log(`${id} , ${ticket} , ${mode}`);
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         this.doSearch();
       },

      //  async doDeleteLoad(){
      //   const request = this.getSelectedItems[0];
      //     console.log(request);
      //     const data = {
      //       companyOffice: "GST_" + request.salesOffice,
      //       loadKeyWithStageNo: request.loadKeyWithStageNo,
      //       type: request.type || "YY",
      //       loadKey: request.seqNo,
      //       action: "DELETE_LOAD",
      //     }

      //     api.post("/api/w/gst/WebCopyDeleteStage", data)
      //     .then(() => {
      //       this.$store.commit('clearApiError');
      //       this.doSearch();
      //     });

      //  }, 


       doClear(){
        this.filter = "";
        this.selectDType = "YE";

        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
      this.$nextTick(() => {
          this.searchRequest = getInitSearch();
          this.searchRequest.salesOffice = 'LGB';

        });

       },


    //    async doChange(){
         
    //     const request = this.getSelectedItems[0];
    //       if (request.loadKeyWithStageNo == null)
    //       {
    //         alert('There is no stage selected');
    //         return;
    //       }

    //       if (request.stageStatus == 'STC' || request.stageStatus == 'SUC'  )
    //       {
    //         alert('The stage has been confirmed or under check, it can not be changed this time!');
    //         return;
    //       }

    //       this.$refs.DispatchFormChange.openDialog(request);

    // },


    // async doCopy(){
    //     const request = this.getSelectedItems[0];
    //       if (request.loadKeyWithStageNo == null)
    //       {
    //         alert('There is no stage selected');
    //         return;
    //       }

    //       this.$refs.DispatchFormCopy.openDialog(request);

    // },

    // doDispatch(){
    //     do {
    //         this.selectedItems.pop();
    //     } while (this.selectedItems.length > 0)
    //     console.log("selectedItems length: " + this.selectedItems.length);
    //     var items = this.items.forEach( it => {
    //       if (it.selected == true)
    //       {
    //         console.log("selected: " + it.selected);
    //         this.selectedItems.push(it);
    //       }
    //     })
    //     console.log("dispatch items: " + JSON.stringify(this.selectedItems));
    //     const request = this.selectedItems[0];
    //     this.$refs.DispatchFormCopy.openDialog(request);

    // },

    // doSingleDispatch(item){
    //     // const request = item;
    //     // this.$refs.DispatchFormCopy.openDialog(request);
    //     console.log("single dispatch item: " + JSON.stringify(item));
    //     if (item.loadKey == null)
    //        item.loadKey = item.seqNo;
    //     this.singleReq.push(item);    
    //     this.$router.push({  
    //           name: "confirmDetail" , 
    //           params: { req: JSON.stringify(this.singleReq) }
    //     })

    // },

    getMasterDataByName(group, tagId) {
        //console.log("get master data name: " + group + ", " + tagId);
        if (!tagId) {
          return "";
        }
        //console.log("master name: " + this.getMasterDataName(group, tagId));
        return this.getMasterDataName(group, tagId);
        //return "";
    },

    handleTypeChanged(id) {
        this.searchRequest.type = id;
      },


    
    handleCarrierChanged(id) {
        this.searchRequest.carrier = id;
      },


    handleDriverRequestChanged(id) {
        this.searchRequest.driver = id;
      },


      changeAsgDriverId(item) {
        return (id, name, unit, weight, plate, trail) => {
          console.log("driver Id: " + id + " plate: " + plate);
          item.driverId = id;
          item.truckId = plate;
          //item.driverPh = name;
          //item.driverLP = plate;
          // item.containerNo = trail;
          console.log("driver Id in item: " + item.driverId);
          
        };
      },

      changeDriverGroup(item) {
        return (driverGroup) => {
          if (driverGroup) {
            console.log("driver Group: " + item.driverGroup);
            item.driverGroup = driverGroup.tagId;
          }
        }

      },

      showApptDate(item) {
        console.log("item apptDate: " + item.apptDate);
        if (item.apptDate != "12/31/1969" && item.apptDate != null && item.apptDate != "") {
        var date = new Date(item.apptDate);
        //var date = new Date("1/1/2022"); 
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var year = date.getFullYear();
        console.log("day length:" + day.toString().length);
        if (day.toString().length < 2)
          day = '0' + day;
        if (month.toString().length < 2)
          month = '0' + month;
        console.log("date: " + date);
        //console.log("test date: " + Date("1/1/2022"));
        console.log("month: " + month + " day: " + day + " year: " + year);
         item.apptDate = month + "/" + day + "/" + year;
         return item.apptDate;
        }
        else {
          item.apptDate = "";
          return "";
        }
      },





      handlePushStatusChanged(id) {
        this.searchRequest.pushStatus = id;
      },
      
      doUnconf() {
         if (this.getSelectedItems[0].loadStatus != "CFM"){
            window.confirm('LoadStatus is not CFM')
            return;
         }
         const seqNo = this.getSelectedItems[0].seqNo;
         const billingNum = this.getSelectedItems[0].billingNum;
         const salesOffice = this.getSelectedItems[0].salesOffice;

         //api
         //   .post("/api/w/apar/create", {
         newAPIPost("/api/w/apar/create", {
               mode: "loadUnCFM",
               user: "GST_SYSTEM",
               username: this.getUserProfile.username,
               seqNo: seqNo,
               billingNum: billingNum,
               salesOffice: salesOffice
            })
            .then((res) => {
               this.showDialog = true;
               this.$store.commit("clearApiError");
               this.paramList.loadStatus = "DCP";
               this.params.loadStatus = "DCP";
               this.item.loadStatus = "DCP";
               window.confirm(res);
            });

        //  api
        //     .post("/api/w/gst/WebConfirmLoad", {
        //        mode: "loadUnCFM",
        //        user: "GST_SYSTEM",
        //        username: this.getUserProfile.username,
        //        seqNo: seqNo,
        //        billingNum: billingNum,
        //        salesOffice: salesOffice
        //     })
        //     .then((res) => {
        //        this.showDialog = true;
        //        this.$store.commit("clearApiError");
        //        this.paramList.loadStatus = "DCP";
        //        this.params.loadStatus = "DCP";
        //        this.item.loadStatus = "DCP";
        //        window.confirm(res);
        //     });
         this.doSearch();
        
      },

      doCockPit() {
        const request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
          //console.log(request);
          request.forEach((it) => {
            if (this.selectDType == "YE") it.mode = "YY";
            if (this.selectDType == "E") it.mode = "YE";
            if (this.selectDType == "I") it.mode = "YI";
            if (this.selectDType == "TL") it.mode = "YT";
            //it.mode = this.selectDType;
            //it.carrierName = "";
            //it.customerPO = "";
            it.route = "";
            //it.deliveryOrder = "";
            if (it.loadKey == null)
            {
              it.loadKey = it.seqNo;
            }
          });
          // this.searchCriteria.containerNo = this.searchRequest.containerNo;
          // this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
          // this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
          // this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
          // this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
          // this.searchCriteria.destination = this.searchRequest.destination;
          // this.searchCriteria.appointment = this.searchRequest.appointment;
          // this.searchCriteria.driverId = this.searchRequest.driverId;
          // this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
          // this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
          // this.searchCriteria.freightType = this.searchRequest.freightType;
          // this.searchCriteria.loadKey = this.searchRequest.loadKey;
          // this.searchCriteria.source = this.searchRequest.source;
          // this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
          // this.searchCriteria.carrier = this.searchRequest.carrier
          // this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
          // this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
          // this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
          // this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
          // this.searchCriteria.stageType = this.searchRequest.stageType;
          // this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
          // this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
          // this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          // this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
          // this.searchCriteria.filter = this.filter;
          // this.searchCriteria.fromPage = "L";
          // this.searchCriteria.selectDType = this.selectDType;

          //store and saved this page state info before to another page
          this.pageStateInfo.receivingWindow = this.searchRequest.receivingWindow;
          this.pageStateInfo.loadStatus = this.searchRequest.loadStatus;
          this.pageStateInfo.carrier = this.searchRequest.carrier;
          this.pageStateInfo.pickupLocation = this.searchRequest.pickupLocation;
          this.pageStateInfo.destination = this.searchRequest.destination;
          this.pageStateInfo.containerNo = this.searchRequest.containerNo;
          this.pageStateInfo.selectDType = this.selectDType;
          this.pageStateInfo.stageType = this.searchRequest.stageType;
          this.pageStateInfo.freightType = this.searchRequest.freightType;
          this.pageStateInfo.ctnrType = this.searchRequest.ctnrType;
          this.pageStateInfo.stageStatus = this.searchRequest.stageStatus;
          this.pageStateInfo.pushStatus = this.searchRequest.pushStatus;
          this.pageStateInfo.apptDate.startDate = this.searchRequest.apptDate.startDate;
          this.pageStateInfo.apptDate.endDate = this.searchRequest.apptDate.endDate;
          this.pageStateInfo.cargoCutOff.startDate = this.searchRequest.startDate;
          this.pageStateInfo.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          this.pageStateInfo.driverGroup = this.searchRequest.driverGroup;
          this.pageStateInfo.driver = this.searchRequest.driver;
          this.pageStateInfo.deliveryOrder = this.searchRequest.deliveryOrder;
          this.pageStateInfo.customerOrder = this.searchRequest.customerOrder;
          this.pageStateInfo.appointment = this.searchRequest.appointment;

          console.log("request for confirmapaploaddetail: " + JSON.stringify(request));
          //request.push(this.searchCriteria);
          this.$router.push({  
            name: "Load Billing Detail" , 
            //params: { req: JSON.stringify(request) }})
            //params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.pageStateInfo)}})


          // console.log("request for confirmloaddetail: " + JSON.stringify(request));
          // this.$router.push({  
          //   name: "Load Detail" , 
          //   params: { req: JSON.stringify(request) }})

      },




      getChassisUsedDate(item){
          if (item.chzEndDate == null)
          {
            return moment().diff(moment(item.chzStartDate), 'days')
          }
          else
          {
            return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days')
          }
      },

      getPushStatusInfo(status) {
       var retStatus = "";
       console.log("push status: " + status);
       if (status && status != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retStatus = this.getMasterDataName("PUSH_STATUS",status);
          console.log("return type: " + retStatus);
       }
       return retStatus;     
    },

      async doOutGate(){
          const request = this.getSelectedItems;
          if (request.filter(it => it.stageType == "OUT" || it.stageType == null).length != 0)
          {
            alert("Can not out gate for this item!");
            return 
          }
          const data = request.map(it => ({
            salesOffice: it.salesOffice,
            user: it.user,
            type: it.type,
            appointment: it.appointment,
            apptDate: dateFormat.getLocalDate(it.apptDate),
            //pickupDate: dateFormat.getLocalDate(it.pickupDate),
            driverId: it.driverId,
            truckId: it.truckId,
            chassisStartDate :dateFormat.getLocalDate(moment())
          }));


          //await api.post("/api/w/gst/WebYardGroupOutGate", data)
          await newAPIPost("/api/w/gst/WebYardGroupOutGate", data)
          .then(() => {
            this.$store.commit('clearApiError');
            // $('.btn-search-loadlist-container')
            //   .click();
          });
          this.doSearch();

      },


      // doDownloadExcel(){
      //  const request = toGenerateExcelRequest(
      //     this.$el.querySelector('.data-table-container .inner-container'),
      //     'Dispatch-YardExport.xls',
      //     1,
      //   );
      //     //request.heads = _(request.heads).take(52);
      //     request.heads = _(request.heads).take(38);
      //     request.rows = _(this.items)
      //     .map(item => [
      //       // item.logId,
      //       // item.yard,
      //       // item.gateTypeDesc,
      //       // item.gateNo,
      //       // item.statusTypeDesc,
      //       // dateFormat.date(item.logDateTime),
      //       // dateFormat.time(item.logDateTime),
      //       // item.plateNo,
      //       // item.plateImage,
      //       // item.containerNo,
      //       // item.containerType,
      //       // this.getMasterDataByName("CCR_CNTRTYPE",item.containerType),
      //       // this.getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType),
      //       // item.containerImage,
      //       // item.chassisNo,
      //       // item.chassisImage,
      //       // item.scaleWeight,
      //       // item.logStatus,
      //       // item.status,
      //       // item.inboundShipment,
      //       // item.seqNo,
      //       // item.createdBy,
      //       // dateFormat.date(item.createdAt),
      //       // dateFormat.time(item.createdAt),
      //       // item.updatedBy,
      //       // dateFormat.date(item.updatedAt),
      //       // dateFormat.time(item.updatedAt),
      //       item.salesOffice,
      //       item.loadStatus,
      //       item.stageStatus,
      //       item.loadKey,
      //       item.containerNo,
      //       item.chassisNo,
      //       item.carrier,
      //       item.yard,
      //       item.stage,
      //       item.stageType,
      //       item.bookingNo,
      //       item.customerOrder,
      //       item.ctnrType,
      //       item.cutLFD,
      //       //item.deliveryTo,
      //       dateFormat.date(item.apptDate),
      //       dateFormat.time(item.apptDate),
      //       item.appointment,
      //       item.driverId,
      //       item.truckerId,
      //       item.pickupLocationCode,
      //       this.getMasterDataByName("GST_LOCATION",item.pickupLocationCode),
      //       item.deliverLocationCode,
      //       this.getMasterDataByName("GST_LOCATION",item.deliverLocationCode),
      //       item.dispatcherInstruction,
      //       item.costRelevant,
      //       item.source,
      //       item.freightType,
      //       dateFormat.date(item.chzStartDate),
      //       dateFormat.date(item.pickupDate),
      //       item.deliveryOrder,
      //       item.deliveryOrderItem,
      //       item.customerRef,
      //       item.route,
      //       item.routeDesc,
      //       item.createdBy,
      //       dateFormat.date(item.createdAt),
      //       item.updatedBy,
      //       dateFormat.date(item.updatedAt),

      //     ]);
      //   this.$store.dispatch('generateExcel', request)
      //     .then((res) => {
      //       window.open(res.url, 'blank');
      //     });
      // },




      hasBeenChanged(item) {

        const lhs = _(this.getYardExportList)
          .find(it => it.vueKey === item.vueKey);
        
        if (lhs) {
          return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
            || (lhs.driverGroup !== item.driverGroup)
            || (lhs.appointment !== item.appointment)
            || (lhs.driverId !== item.driverId)
            || (lhs.truckId !== item.truckId)
            || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
            || (lhs.costRelevant !== item.costRelevant)
            || (lhs.freightType !== item.freightType)
            || (lhs.pickupLocationCode != item.pickupLocationCode)
            || (lhs.deliverLocationCode != item.deliverLocationCode);
        }
        return false;
      },

     changeSelChkBox() {
        console.log("change check box: " + this.selectAll);
        console.log("yard export list: " +  JSON.stringify(_(this.items)));
        _(this.items).forEach(
          it => {
            //console.log("check box item: " + JSON.parse(JSON.stringify(it)));
            it.selected = this.selectAll;
          }
        );
     },

     handleDriverChanged(item) {
        return (id) => {
          item.driverId = id;
        };
      },






        async CreateIngate(){
            const selectedItem = this.getSelectedItems[0];
            this.$refs.DispatchForm.openDialog(selectedItem);
        //     const req = {
        //       companyOffice: 'GST_' + selectedItem.salesOffice,
        //       loadKey: selectedItem.seqNo,
        //       stageType: 'IN',
        //       stageTypeWithStatus: 'YY'
        //     }
        //  await  api.post("/api/w/gst/createyardstage", req)
        //   .then(() => {
        //     this.$store.commit('clearApiError');
        //     // $('.btn-search-loadlist-container')
        //     //   .click();
        //   });

         // this.doSearch();


           

        },



        getChassisUsedDate(date){
            return moment().diff(moment(date), 'days')
 
        },



        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
         
          this.active = !this.active;
        },


        getDriverName(item){
            const driver = this.drivers.filter(it => it.id == item);
          
            return  driver.length == 0 ? "" : driver[0].name
        },


      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },


      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },


      includeNull(field){
            return field==null ? '' : field;
      },

      isValidCond(values) {
         if (values == null) return false;
         if (values[0])
            return (values.length === 1 && values[0].toString() != "");
         else
            return false;   
      }
      

     },

    }
</script>